<template>
  <div :class="[baseCss, vertical ? 'bcq-btn-group-vertical' : null, fancy || rounded ? ['overflow-hidden'] : null, fancy ? 'rounded-full' : null, rounded ? 'rounded' : null, disabled ? ['disabled', 'pointer-events-none'] : null, `shadow-${elevation}`]">
    <div :is="vertical ? 'div' : 'table-layout'" equal-cells :class="['inline-block']" y-align="middle">
      <div :is="vertical ? 'div' : 'row'">
        <template v-for="(button, index) in buttons">
          <div :is="vertical ? 'div' : 'cell'" :key="`${index}-button`">
            <btn
              @click="onClick(button.value)"
              elevation="none"
              :align="align"
              :outlined="outlined"
              :fancy="fancy"
              :rounded="rounded"
              :title="button.hint"
              :block="vertical"
              :disabled="button.disabled"
              :color="color"
              :color-lightness="colorLightness"
              :bg-color="bgColor"
              :uppercase="uppercase"
              :bold="bold"
              :bg-color-lightness="bgColorLightness"
              :size="size"
              :icon-provider="iconProvider"
              :active="value.includes(button.value) && type !== 'default'"
              :flat="true"
              :icon-left="button.icon"><template v-if="button.label">{{ button.label }}</template></btn>
          </div>
          <cell :is="vertical ? 'div' : 'cell'" :key="`${index}-separator`" :class="['bcq-btn-group-separator']" v-if="!outlined && separators && index < buttons.length - 1" />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'BtnGroup',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      active: [],
      baseCss: this.componentBaseCss('btn-group', ['whitespace-nowrap', 'inline-block', 'align-middle', 'select-none'])
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  mounted () {
    this.setActive()
  },
  props: {
    outlined: {
      type: Boolean
    },
    align: {
      type: String,
      default: 'center'
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    bold: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean
    },
    vertical: {
      type: Boolean
    },
    fancy: {
      type: Boolean
    },
    separators: {
      type: Boolean
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      default: 'default',
      validator: value => {
        return ['default', 'exclusive', 'multiple'].includes(value)
      }
    },
    size: {
      type: String
    },
    buttons: {
      type: Array,
      default: () => {
        return []
      }
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'black'
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    setActive () {
      this.active = []
      this.value.forEach(button => {
        if (this.value.includes(button)) {
          this.active.push(button)
        }
      })
    },
    onClick (value) {
      let modelNew = []
      const modelOld = this.value
      const type = this.type
      const mandatory = this.mandatory
      switch (type) {
        case 'multiple':
          if (!modelOld.includes(value)) {
            modelNew = modelNew.concat(value).concat(modelOld)
          } else {
            const index = this.value.findIndex(item => item === value)
            modelNew = modelOld
            modelNew.splice(index, 1)
          }
          break
        case 'exclusive':
          if (!mandatory && !modelOld.includes(value)) {
            modelNew.push(value)
          } else if (mandatory && modelOld.includes(value)) {
            return
          } else if (mandatory && !modelOld.includes(value)) {
            modelNew.push(value)
          }
          break
        default:
          modelNew.push(value)
      }
      this.$emit('input', modelNew)
    }
  }
}
</script>
<style>
.bcq-btn-group .bcq-table-layout
{
  width: auto;
}

.bcq-btn-group .bcq-btn-group-separator
{
  width: 1px;
  background: white;
}

.bcq-btn-group.bcq-btn-group-vertical .bcq-btn-group-separator
{
  height: 1px;
}

.bcq-ui-theme-dark .bcq-btn-group .bcq-btn-group-separator
{
  background: var(--semi-transparent-dark);
}

.bcq-btn-group:not(.bcq-btn-group-vertical) .bcq-table-layout-cell:not(:last-of-type) .bcq-btn.border
{
  border-right: 0;
}

.bcq-btn-group.bcq-btn-group-vertical div:not(:last-of-type) .bcq-btn.border
{
  border-bottom: 0;
}

.bcq-btn-group:not(.bcq-btn-group-vertical) .bcq-table-layout-cell:not(:last-of-type) .bcq-btn
{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.bcq-btn-group:not(.bcq-btn-group-vertical) .bcq-table-layout-cell:not(:first-of-type) .bcq-btn
{
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.bcq-btn-group.bcq-btn-group-vertical div:not(:last-of-type) .bcq-btn
{
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.bcq-btn-group.bcq-btn-group-vertical div:not(:first-of-type) .bcq-btn
{
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/btn-group/btn-group.vue